import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const viewControlsTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      container: {
        background: theme.color.surface[3],
        border: theme.color.surface[3],
        borderRadius: theme.size.radius['radius-medium'],
      },
      header: {
        background: theme.color.surface[2],
        text: theme.color.text.core['-primary'],
        border: theme.color.surface[3],
      },
      tabs: {
        background: theme.color.surface[3],
        selectedBackground: theme.color.surface[2],
        icon: theme.color.text.core['-secondary'],
        selectedIcon: theme.color.text.core['-primary'],
        border: 'transparent',
        selectedBorder: theme.color.focus[4],
      },
      toggle: {
        background: theme.color.surface[4],
        selectedBackground: theme.color.surface[1],
        selectedText: theme.color.text.core['-primary'],
        text: theme.color.text.core['-secondary'],
        border: theme.color.surface[4],
      },
      button: {
        primary: {
          background: theme.color.control.button.primary,
          text: theme.color.text.core['on-dark-primary'],
          hover: theme.color.control.button['primary-hover'],
        },
        secondary: {
          background: theme.color.control.button.secondary,
          text: theme.color.text.core['-primary'],
          hover: theme.color.control.button['secondary-hover'],
          border: theme.color.surface[3],
        },
        icon: {
          background: 'transparent',
          text: theme.color.text.core['-secondary'],
          hover: theme.color.surface[2],
        },
      },
      content: {
        background: theme.color.surface[0],
        text: theme.color.text.core['-primary'],
        textSecondary: theme.color.text.core['-secondary'],
      },
      divider: {
        color: theme.color.surface[3],
      },
    },
  ]),
);
